module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_25.9d491a26.png";